import React from "react";
import Container from "../common/container";
import P from "../common/p";
import Title from "../common/title";

export default function Info() {
  return (
    <Container>
      <Title text="this is info here" />
      <P>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Delectus alias
        iste, distinctio ad perspiciatis tempore nesciunt veritatis quam
        perferendis eligendi nobis doloremque neque culpa sit recusandae nihil
        ducimus aliquid aspernatur voluptas. Aspernatur dolorem praesentium
        aliquam nam modi! Animi inventore ad expedita quod blanditiis debitis ea
        harum doloremque officiis fugit! Nobis.
      </P>
    </Container>
  );
}
